<template>
    <div class="notification">
       <el-form style="width:100%;">
            <el-form-item label="" :label-width="formInputWidth" style="margin-left:-100px;">
              <el-col >
                  <span>{{noticeInfo.title}}</span>
                  <span style="float:right;cursor:default;" @click="handleClose" ><i class="el-icon-close"> </i></span>
              </el-col>
            </el-form-item>
            <el-form-item label="发布人：" :label-width="formInputWidth" >
              <el-col >
                  <span>{{noticeInfo.content.from_admin_name}}</span>
              </el-col>
            </el-form-item>
            <el-form-item label="游戏名称：" :label-width="formInputWidth">
              <el-col :span="18">
                  <span>{{noticeInfo.content.game_name}}</span>
              </el-col>
            </el-form-item>
            <el-form-item label="被通知人：" :label-width="formInputWidth" >
              <el-col >
                  <span>{{noticeInfo.content.to_admin_name}}</span>
              </el-col>
            </el-form-item>
            <el-form-item label="通知内容：" :label-width="formInputWidth" :show-overflow-tooltip="true">
              <el-col >
                  <span>{{noticeInfo.content.content}}</span>
              </el-col>
            </el-form-item>
            <el-form-item label="钉钉通知内容：" :label-width="formInputWidth" :show-overflow-tooltip="true" v-if="dingShow">
              <el-col >
                  <span>{{noticeInfo.content.ding_content}}</span>
              </el-col>
            </el-form-item>
            
            <el-form-item label="" :label-width="formInputWidth">
              <el-col >
                 <el-button  @click.native="handleJump">查看</el-button>
              </el-col>
            </el-form-item>
       </el-form>
    </div>
</template>
 
<script>
export default {
  name: 'noticePopup',
  props: {
    noticeInfo: {
      type: Object,
      required: true
    }
  },
  computed:{
    dingShow() {
      let data = ""
      if(this.noticeInfo.content.ding_content !=""){
        data = true;
      }
      else{
        data = false;
      }
      return data;
    }
  },
  data() {
    return {
        formInputWidth:"120px",
        }
  },
  methods: {
    handleJump (e) {
      e.preventDefault()
      this.$emit('JumpPage')
    },
    handleClose (e) {
      e.preventDefault()
      this.$emit('closeNotice')
    },
  }
}
</script>
 
<style  scoped>
.notification{
  display: flex;
  background-color :white;
  color :black;
  align-items :center;
  padding :10px;
  position: fixed;
  bottom:20px;
  right:40px;
  min-width :280px;
  max-width:400px;
  box-shadow :0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.8);
  z-index:10;
}
.fixed_wrap{
   height:50px;
}
.content{
      padding :0;
}
</style>